import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/* Third party Modules */
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { SweetAlert2Module } from '@toverux/ngx-sweetalert2';
import { ToastrModule } from 'ngx-toastr';

import { CoreRoutingModule } from './core-routing.module';
import { LayoutModule } from './layout/secure/layout.module';
import { AuthModule } from './auth/auth.module';
import { UserModule } from './user/user.module';
import { PublicLayoutComponent } from './layout/public/public-layout.component';
import { LayoutComponent } from './layout/secure/layouts/normal/layout.component';
import { EnumTextValuesPipe } from '../shared/pipes/enum-keys-text.pipe';
import { EnumKeysPipe } from '../shared/pipes/enum-keys.pipe';
import { EnumStringsPipe } from '../shared/pipes/enum-strings.pipe';
import { ExternalLayoutComponent } from './layout/external/external-layout.component';


@NgModule({
  imports: [
    CommonModule,
    CoreRoutingModule,
    LayoutModule,
    AuthModule,
    UserModule,
    LoggerModule.forRoot({serverLoggingUrl: '/api/logs', level: NgxLoggerLevel.DEBUG, serverLogLevel: NgxLoggerLevel.ERROR}),
    ToastrModule.forRoot(),
    SweetAlert2Module.forRoot(),
  ],
  exports: [
    LayoutComponent,
    PublicLayoutComponent,
    ExternalLayoutComponent,
  ],
  declarations: [
    PublicLayoutComponent,
    ExternalLayoutComponent
  ],
  providers: [
    EnumTextValuesPipe,
    EnumKeysPipe,
    EnumStringsPipe
  ]
})
export class CoreModule { }



// WEBPACK FOOTER //
// ./client/app/core/core.module.ts